import { Link } from "react-router-dom";
import CountUp from 'react-countup';
import api from "../services/api";
import { useEffect, useState } from "react";

export default function ServicesMenuProvincia({ tipo, provincia }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    api.get(`/estabelecimentos?provincia=${provincia}&tipoId=${tipo._id}&count=true`)
      .then(r => setCount(r.data.totalItems ?? 0))
      .catch(() => {});
  }, [provincia, tipo._id]);

  return (
    <Link
      to={`/admin/provincia/${provincia}/${tipo._id}`}
      className={[
        'tw-flex tw-flex-col tw-items-center tw-justify-between',
        'tw-w-[160px] tw-min-w-[140px] tw-h-[130px]',
        'tw-bg-white tw-rounded-xl tw-border tw-border-[#85287e]/30',
        'tw-shadow-sm tw-no-underline tw-text-inherit',
        'tw-transition-all tw-duration-300',
        'hover:tw-bg-[#85287e]/10 hover:tw-border-[#85287e]',
        'hover:tw-shadow-md hover:tw--translate-y-0.5',
        'tw-cursor-pointer tw-overflow-hidden',
      ].join(' ')}
    >
      {/* Nome do tipo */}
      <div className="tw-flex-1 tw-flex tw-items-center tw-justify-center tw-px-3 tw-pt-3">
        <p className="tw-text-[12px] tw-font-bold tw-text-gray-700 tw-uppercase tw-tracking-wide tw-text-center tw-leading-snug">
          {tipo?.designacao}
        </p>
      </div>

      {/* Contador */}
      <div className="tw-w-full tw-text-center tw-py-2 tw-border-t tw-border-[#85287e]/20 tw-bg-[#85287e]/5">
        <span className="tw-text-xl tw-font-extrabold tw-text-[#85287e]">
          <CountUp end={count} />
        </span>
      </div>
    </Link>
  );
}
